// PolicyTypes.ts

import { USER_ROLE } from  '@src/utils/constants.ts'

export interface Policy {
  action: string
  resourceType: string
  effect: string
  conditions: Condition[]
}

export interface Condition {
  attribute: keyof User
  value: string
}

export interface User {
  id: string
  userRole: string[]
  roles: string[]
  accessInfo: string[]
  viewAccSetting: string
}

export const policyData: Policy[] = [
  {
    // only admin, account_admin , user can see create users
    action: 'create',
    resourceType: 'User',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }
    ]
  },
  {
    // only account_admin, admin can edit users
    action: 'edit',
    resourceType: 'User',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }
    ]
  },
  {
    // only account_admin can lock/unlock users
    action: 'lock_unlock',
    resourceType: 'User',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      }
    ]
  },

  // Learner policies
  {
    // only admin, account_admin , user can create learner
    action: 'create',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }
    ]
  },
  {
    // Parent can create learner
    action: 'create',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'roles',
        value:  USER_ROLE.PARENT
      } 
    ]
  },
  {
    // only account_admin, admin can edit users
    action: 'edit',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      },
      // {
      //   attribute: 'roles', 
      //   value: USER_ROLE.PARENT
      // }
    ]
  },
  
  {
    // only account_admin, admin,user can create goal
    action: 'add_goal',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }
    ]
  },
  {
    // only account_admin, admin,user can edit goal
    action: 'edit_goal',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }
    ]
  },
  {
    // only account_admin, admin , user and parent can edit activity status
    action: 'edit_activity',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }, 
      {
        attribute: 'roles', 
        value: USER_ROLE.PARENT
      }
    ]
  },
  {
    // only account_admin, admin , user can edit activity status
    action: 'enroll_curriculum',
    resourceType: 'Learner',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.USER
      }
    ]
  },
  {
    // only user with roles super_admin can see create user in other accounts
    action: 'create',
    resourceType: 'GlobalUser',
    effect: 'all',
    conditions: [
      {
        attribute: 'roles', 
        value:  USER_ROLE.SUPER_ADMIN
      } 
    ]
  },
  {
    // only user with roles super_admin can edit user in other accounts
    action: 'edit',
    resourceType: 'GlobalAccount',
    effect: 'all',
    conditions: [
      {
        attribute: 'roles', 
        value:  USER_ROLE.SUPER_ADMIN
      } 
    ]
  },
  {
    // only user with roles super_admin can edit user in other accounts
    action: 'edit',
    resourceType: 'Account',
    effect: 'all',
    conditions: [
      {
        attribute: 'userRole', 
        value:  USER_ROLE.ACCOUNT_ADMIN
      } 
    ]
  },{
    // only user with roles operations can see accounts menu
    action: 'view_menu',
    resourceType: 'AdminAccounts',
    effect: 'any',
    conditions: [
      {
        attribute: 'roles', 
        value:  USER_ROLE.OPERATION
      }
    ]
  },
  {
    // only user with roles operations can see accounts menu
    action: 'view_menu',
    resourceType: 'AdminRobots',
    effect: 'any',
    conditions: [
      {
        attribute: 'roles', 
        value:  USER_ROLE.OPERATION
      }
    ]
  },
  {
    // only user with roles operations can see accounts menu
    action: 'view_menu',
    resourceType: 'AdminSubscriptions',
    effect: 'any',
    conditions: [
      {
        attribute: 'roles', 
        value:  USER_ROLE.OPERATION
      }
    ]
  },
  {
    // only user with roles accoutn admin can see accounts menu
    action: 'view_menu',
    resourceType: 'Accounts',
    effect: 'all',
    conditions: [
      {
        attribute: 'userRole', 
        value:  USER_ROLE.ACCOUNT_ADMIN
      } 
    ]
  },
  {
    // only user with roles account admin and attribute viewAccSetting can see account settings menu
    action: 'view_menu',
    resourceType: 'AccountSettings',
    effect: 'all',
    conditions: [
      {
        attribute: 'userRole', 
        value:  USER_ROLE.ACCOUNT_ADMIN
      }, {
        attribute: 'viewAccSetting', 
        value: 'true'
      }
    ]
  },{
    // only account_admin, admin  can view  my account
    action: 'view_menu',
    resourceType: 'MyAccount',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      }
    ]
  },
  {
    // only account_admin, admin  can view analytics
    action: 'view_menu',
    resourceType: 'Analytics',
    effect: 'any',
    conditions: [
      {
        attribute: 'userRole',
        value: USER_ROLE.ACCOUNT_ADMIN
      },
      {
        attribute: 'userRole',
        value: USER_ROLE.ADMIN
      }
    ]
  },
]
